export const DEFAULT_OPTION = { label: 'Default', value: 'default' };

export const SORT_ORDER_OPTIONS = [
  { label: 'Default', value: 'default' },
  { label: 'Ascending (A-Z)', value: 'asc' },
  { label: 'Descending (Z-A)', value: 'desc' },
];
